












import { Vue, Component, Prop } from 'vue-property-decorator'
import { limitarPercentual } from '@/shareds/painel-do-cliente-shareds'

@Component
export default class BarraDePercentual extends Vue {
	@Prop({ type: Number, default: null }) percentual!: number | null
	@Prop({ type: String, required: true }) cor!: string

	get largura() {
		return limitarPercentual(this.percentual)
	}
}
